import { KeepAlive } from "vue";

export function getRouter(data, newRoutes) {
  return new Promise((resolve) => {
    data.forEach((l) => {
      // 1 菜单  2 页面  3 按钮
      if (l.menuType == 1) {
        let item = {
          path: l.componentPath,
          name: l.componentName,
          component: (resolve) =>
            require(["@/views/" + (l.url ? l.url : "index")], resolve),
          meta: {
            title: l.name,
            icon: l.icon,
            keepAlive: l.meta && l.meta.keepAlive,
            needRefresh: l.meta && l.meta.needRefresh,
          },
          children: [],
        };
        newRoutes.push(item);
        getRouter(l.children, item.children);
      } else if (l.menuType == 2) {
        if (l.menuParentId == "0") {
          newRoutes.push({
            path: "/",
            name: "",
            component: () => import("@/views/index"),
            redirect: l.componentPath,
            children: [
              {
                path: l.componentPath,
                name: l.componentName,
                component: (resolve) => require(["@/views/" + l.url], resolve),
                meta: {
                  title: l.name,
                  icon: l.icon,
                  keepAlive: l.meta && l.meta.keepAlive,
                  needRefresh: l.meta && l.meta.needRefresh,
                },
              },
            ],
          });
        } else {
          newRoutes.push({
            path: l.componentPath,
            name: l.componentName,
            component: (resolve) => require(["@/views/" + l.url], resolve),
            meta: {
              title: l.name,
              icon: l.icon,
              keepAlive: l.meta && l.meta.keepAlive,
              needRefresh: l.meta && l.meta.needRefresh,
            },
          });
        }
      }
    });
    resolve(newRoutes);
  });
}



// WEBPACK FOOTER //
// ./src/router/router.js